import { type NotificationsKind } from '@core/notifications';

import { type NotificationsCopy } from './notifications.types';

export function notificationsCopy(kind: NotificationsKind): NotificationsCopy {
  if (kind === 'notifications') {
    return {
      titleKey: 'header.notifications.title',
      emptyTitleKey: 'header.notifications.emptyTitle',
      emptyDescriptionKey: 'header.notifications.emptyDescription',
      illustration: 'assets/icon/empty-notification.svg',
    };
  }

  return {
    titleKey: 'header.messages.title',
    emptyTitleKey: 'header.messages.emptyTitle',
    emptyDescriptionKey: 'header.messages.emptyDescription',
    illustration: 'assets/icon/empty-message.svg',
  };
}
